import React, { useState } from "react";
import "./SetupPage.css";

const SetupPage = ({ userGroups = [] }) => {
  const [step, setStep] = useState(0);
  const [requiredFields, setRequiredFields] = useState({
    user_name: false,
    user_surname: false,
    user_nickname: false,
    date_of_birth: false,
    user_gender: false,
    user_mobile: false,
    user_email: false,
    user_address: false,
    user_emergency_contact: false,
    user_availability: false,
    user_consent_checkbox: false,
  });
  const [additionalFields, setAdditionalFields] = useState({
    video_welcome_message: false,
    video_welcome_message_links: [],
    training_materials: false,
    training_materials_files: [],
  });
  const [generatedLink, setGeneratedLink] = useState("");
  const [isFormSaved, setIsFormSaved] = useState(false);

  // Check if user belongs to Galereya
  const isGalereya = userGroups.includes("Galereya");
  // Determine place_id based on school
  // const place_id = isGalereya ? "glra12a4a6" : "test77a7a7";
  const place_id = "glra12a4a6";

  const handleRequiredFieldChange = (field) => {
    setRequiredFields({ ...requiredFields, [field]: !requiredFields[field] });
  };

  const handleAdditionalFieldChange = (field) => {
    setAdditionalFields({
      ...additionalFields,
      [field]: !additionalFields[field],
    });
  };

  const handleFileUpload = (e) => {
    setAdditionalFields({
      ...additionalFields,
      training_materials_files: Array.from(e.target.files),
    });
  };

  const generateLink = () => {
    const link = `foqus.in/${place_id}`;
    setGeneratedLink(link);
  };

  const handleSave = async () => {
    try {
      const response = await fetch(
        "https://t9t3cfvgj1.execute-api.eu-west-1.amazonaws.com/dev/setup-configuration",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            action: "save",
            place_id: place_id,
            required_fields: requiredFields,
            custom_onboarding_steps: {
              video_welcome_message: additionalFields.video_welcome_message
                ? additionalFields.video_welcome_message_links
                : [],
              training_materials: additionalFields.training_materials
                ? additionalFields.training_materials_files.map((file) =>
                    URL.createObjectURL(file)
                  )
                : [],
            },
            consent_policy:
              "data:@file/pdf;base64,iVBORw0KGgoAAAANSUhEUgAACC8AAApWCAIAAADO2+b5AAEAAElEQVR4nOzddXwUx/",
          }),
        }
      );

      const data = await response.json();
      if (response.status === 200) {
        generateLink();
        setIsFormSaved(true);
      } else {
        console.error("Error saving data:", data.error);
      }
    } catch (error) {
      console.error("API request failed:", error);
    }
  };

  const handleEdit = () => {
    setIsFormSaved(false);
  };

  const handleDelete = () => {
    setGeneratedLink("");
    setIsFormSaved(false);
    setStep(0);
    setRequiredFields({
      user_name: false,
      user_surname: false,
      user_nickname: false,
      date_of_birth: false,
      user_gender: false,
      user_mobile: false,
      user_email: false,
      user_address: false,
      user_emergency_contact: false,
      user_availability: false,
      user_consent_checkbox: false,
    });
    setAdditionalFields({
      video_welcome_message: false,
      video_welcome_message_links: [],
      training_materials: false,
      training_materials_files: [],
    });
  };

  return (
    <div className="setup-page">
      <h1>Регистрационная форма</h1>
      <p>
        Настройте форму, которую увидят ваши сотрудники при заполнении своих
        данных
      </p>

      {!isFormSaved ? (
        <>
          {step === 0 && (
            <button className="create-form-button" onClick={() => setStep(1)}>
              Создать форму
            </button>
          )}

          {step > 0 && (
            <div className="setup-form">
              <div className="navigation-bar">
                <div className={`nav-step ${step === 1 ? "active" : ""}`}>
                  <div className="step-circle">1</div>
                  <div className="step-label">Обязательные поля</div>
                </div>
                <div className={`nav-step ${step === 2 ? "active" : ""}`}>
                  <div className="step-circle">2</div>
                  <div className="step-label">Дополнительные поля</div>
                </div>
                <div className={`nav-step ${step === 3 ? "active" : ""}`}>
                  <div className="step-circle">3</div>
                  <div className="step-label">Ссылка на форму</div>
                </div>
              </div>

              <div className="step-content">
                {step === 1 && (
                  <>
                    <h2>Обязательные поля</h2>
                    <div className="checkbox-group">
                      {[
                        { key: "user_name", label: "Имя" },
                        { key: "user_surname", label: "Фамилия" },
                        { key: "user_nickname", label: "Никнейм" },
                        { key: "date_of_birth", label: "Дата рождения" },
                        { key: "user_gender", label: "Пол" },
                        { key: "user_mobile", label: "Телефон" },
                        { key: "user_email", label: "Email" },
                        { key: "user_address", label: "Адрес" },
                        {
                          key: "user_emergency_contact",
                          label: "Номер телефона для экстренных случаев",
                        },
                        { key: "user_availability", label: "Занятость" },
                        {
                          key: "user_consent_checkbox",
                          label: "Согласие на обработку данных",
                        },
                      ].map((field) => (
                        <label key={field.key}>
                          <input
                            type="checkbox"
                            checked={requiredFields[field.key]}
                            onChange={() =>
                              handleRequiredFieldChange(field.key)
                            }
                          />
                          {field.label}
                        </label>
                      ))}
                    </div>
                    <div className="form-actions">
                      <button
                        className="cancel-button"
                        onClick={() => setStep(0)}
                      >
                        Отмена
                      </button>
                      <button
                        className="next-button"
                        onClick={() => setStep(2)}
                      >
                        Сохранить и далее
                      </button>
                    </div>
                  </>
                )}

                {step === 2 && (
                  <>
                    <h2>Дополнительные поля</h2>
                    <div className="checkbox-group">
                      <label>
                        <input
                          type="checkbox"
                          checked={additionalFields.video_welcome_message}
                          onChange={() =>
                            handleAdditionalFieldChange("video_welcome_message")
                          }
                        />
                        Приветствующий видео материал
                      </label>
                      {additionalFields.video_welcome_message && (
                        <input
                          type="text"
                          placeholder="Введите ссылку на видео"
                          value={additionalFields.video_welcome_message_links.join(
                            ", "
                          )}
                          onChange={(e) =>
                            setAdditionalFields({
                              ...additionalFields,
                              video_welcome_message_links:
                                e.target.value.split(", "),
                            })
                          }
                        />
                      )}
                      <label>
                        <input
                          type="checkbox"
                          checked={additionalFields.training_materials}
                          onChange={() =>
                            handleAdditionalFieldChange("training_materials")
                          }
                        />
                        Материалы для тренинга (pdf)
                      </label>
                      {additionalFields.training_materials && (
                        <input
                          type="file"
                          multiple
                          accept=".pdf"
                          onChange={handleFileUpload}
                        />
                      )}
                    </div>
                    <div className="form-actions">
                      <button
                        className="cancel-button"
                        onClick={() => setStep(1)}
                      >
                        Назад
                      </button>
                      <button
                        className="next-button"
                        onClick={() => setStep(3)}
                      >
                        Сохранить и далее
                      </button>
                    </div>
                  </>
                )}

                {step === 3 && (
                  <>
                    <h2>Ссылка на форму</h2>
                    <div className="generated-link">
                      <button
                        className="generate-link-button"
                        onClick={generateLink}
                      >
                        Сгенерировать ссылку
                      </button>
                      {generatedLink && (
                        <>
                          <input type="text" value={generatedLink} readOnly />
                          <button
                            onClick={() =>
                              navigator.clipboard.writeText(generatedLink)
                            }
                          >
                            Копировать ссылку
                          </button>
                        </>
                      )}
                    </div>
                    <div className="form-actions">
                      <button
                        className="cancel-button"
                        onClick={() => setStep(2)}
                      >
                        Назад
                      </button>
                      <button className="save-button" onClick={handleSave}>
                        Сохранить
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="saved-form">
          <h2>Ссылка на вашу форму</h2>
          <div className="generated-link">
            <input type="text" value={generatedLink} readOnly />
            <button
              onClick={() => navigator.clipboard.writeText(generatedLink)}
            >
              Копировать ссылку
            </button>
          </div>
          <div className="form-actions">
            <button className="edit-button" onClick={handleEdit}>
              Редактировать
            </button>
            <button className="delete-button" onClick={handleDelete}>
              Удалить форму
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SetupPage;
